let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("k3NDA")).then(() => parcelRequire('98W2t'));